import { useEffect, useState } from "react"
import { useRouter } from "next/router"

import image, { DIRECTOR_AVATAR } from "lacinetek-common/src/images"

import { useTranslation } from "lib/i18n/translation"
import { listComponent } from "lib/tools/categories"
import Gtm from "lib/gtm"

import Film from "components/films/list/film"
import SkeletonLink from "components/common/skeleton-link"
import Image from "components/common/image"

const Search = ({ term }) => {
	const [loading, setLoading] = useState(true)
	const [query, setQuery] = useState("")
	const [results, setResults] = useState({ products: [], lists: [] })
	const { c } = useTranslation("common")
	const router = useRouter()
	const url = router ? router.asPath : null

	const handleSearch = (e) => {
		setResults({ products: [], lists: [] })
		const q = e.target.value
		setQuery(q)

		if (q === "") {
			setResults({ products: [], lists: [] })
			setLoading(false)

			return
		}

		setLoading(true)
		fetch(`/fetch-search/${q}`)
			.then(response => {
				response.json()
					.then(data => {
						setResults(data)
						setLoading(false)
					})
			})
	}

	useEffect(() => {
		handleSearch({ target: { value: term.replace("_", " ") } })
	}, [term])

	return (
		<>
			{!!loading
				&& query
				&& results.products.length > 0
				&& (
					<Gtm
						pageType="Recherche"
						pagePath={url}
						pageTitle={c("search")}
						search={query}
						resultsNumber={results.products.length}
						lists={results.lists.length}
					/>
				)
			}

			<section>
				<h1 className="main-title">{c("search-results-title")}</h1>
				{loading
					? <div className="is-loading" />
					: <>
						{results.products.length > 0 && (
							<div className="films-catalog">
								<ul className="results">
									<li>
										<h2 className="results-title">{c("search-results-films")} : <i>{query}</i></h2>
										<ul className="grid films archive list">
											{results.products.filter(p => p !== undefined).map((product, index) => (
												<Film key={`result-${index}`} film={product} />
											))}
										</ul>
									</li>
								</ul>
							</div>
						)}

						{results.lists.length > 0 && (
							<div id="films-top" className="results-container">
								<ul className="results list">
									<li>
										<h2 className="results-title">{c("search-results-director")}</h2>
										<ul className="grid directors archive">
											{results.lists.map((list, index) => (
												<Director key={`director-${index}`} list={list} />
											))}
										</ul>
									</li>
								</ul>
							</div>
						)}
					</>
				}
			</section>
		</>
	)
}

Search.getInitialProps = async (ctx) => {
	return {
		term: ctx.query.term
	}
}

const Director = ({ list }) => {
	const { c } = useTranslation("common")

	return (
		<li className="item has-extras">
			<div className="item-content">
				<figure>
					<picture>
						<Image src={image(list.director, DIRECTOR_AVATAR)} alt={list.director.name} className="cover" />
					</picture>
				</figure>
				<div className="infos">
					<h3 className="title-alt">{listComponent(list.director, true)}</h3>
				</div>
				<div className="extras">
					<SkeletonLink href="/lists/[id]" as={`/lists/${list.linkRewrite}`}>
						<a title={c("see-quoted-films")} className="more-link">
							<span className="label">{c("see-quoted-films")}</span>
						</a>
					</SkeletonLink>
					<p className="centered"><span className="button small">{c("see-list")}</span></p>
				</div>
			</div>
		</li>
	)
}

export default Search
